<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click.self="$emit('close')">
        <div class="modal-container">
          <div class="modal-top">
            <!-- <h4 class="margin-0 text-red">Vi skal have din accept, fordi</h4> -->
            <h3 style="margin: 0 0 20px 0">Vil du fortsat have nyheder?</h3>
            <p class="text-semimuted margin-0">Du overvåger i øjeblikket <span v-html="followedNames"></span>.</p>
          </div>
          <div class="modal-center">
            <form class="lasso-form">
              <p class="text-semimuted margin-top-bottom-1">Grundet ny EU-lovgivning (GDPR), skal vi bede om din accept til fortsat at måtte sende dig nyheder om firmaer og personer når der registreres ændringer på dem i CVR.</p>
              <p class="text-semimuted margin-bottom-1 margin-top-0">Du accepterer samtidig vores <a href="https://apps.lassox.com/assets/docs/privacy_cookies.pdf" target="_blank">privatlivspolitik</a>, som bl.a. beskriver hvordan vi opbevarer din e-mail.</p>
              <div class="form-group">
                <div class="checkbox" style="margin:0">
                  <input v-model="acceptTerms" type="checkbox" id="checkbox1">
                  <label for="checkbox1" style="margin: 15px 0 0 0; font-weight: 500">
                      Jeg accepterer ovenstående
                  </label>
                </div>
                <!-- <div class="checkbox" style="margin:0">
                  <input v-model="acceptTerms" type="checkbox" id="checkbox1">
                  <label for="checkbox1" style="margin: 0; font-weight: 400">
                      Tilmeld mig Lasso X's nyhedsbrev
                  </label>
                </div> -->
              </div>
            </form>
          </div>
          <div class="modal-bottom text-right padding-top-bottom-2">
            <a class="cancel" @click="$emit('close')">Fortryd</a>
            <button class="btn btn-primary padding-left-right-2" :disabled="!acceptTerms || accepting" @click="accept">FORTSÆT MED AT OVERVÅGE</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { EventBus, Entity } from '@/assets/js/helpers.js'
export default {
  name: 'optInModal',
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      acceptTerms: false,
      accepting: false
    }
  },
  methods: {
    accept () {
      this.accepting = true
      Entity.acceptFollowTerms(this.config.token).then(() => {
        this.accepting = false
        EventBus.$emit('alert', { type: 'success', content: 'Tak - og velkommen tilbage!', duration: 3000 })
        this.$emit('close')
      })
    }
  },
  computed: {
    followedNames () {
      let ents = this.config.entities
      return '<b>' + ents[0].name + '</b>' + (ents[2]
        ? ', <b>' + ents[1].name + '</b> og ' + this.$options.filters.pluralize(ents.length - 2, 'andre', 'anden', 'andre')
        : ents[1] ? ' og <b>' + ents[1].name : '</b>')
    }
  },
  mounted: function () {
  },
  components: {
  }
}
</script>

<style lang="less" scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 85%;
    max-width: 450px;
    margin: 0px auto;
    background-color: #fff;
    border-radius: 2px;
    font-size: 15px;
    line-height: 28px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;

    .modal-top {
      padding: 30px 30px 0 30px;
      // background-color: #f8f8f8;
    }

    .modal-center {
      padding: 0 30px 30px 30px;
      // background-color: #f8f8f8;
    }

    .modal-bottom {
      border-top: 1px solid #ededed;
      border-radius: 0 0 2px 2px;
      padding: 30px;
      a.cancel {
        position: relative;
        top: 2px;
        margin-right: 20px;
        color: #777;
        cursor: pointer;
      }
      // box-shadow: 0 2px 5px -1px rgba(50, 50, 50, 0.2);
      position: relative;
      background-color: #f8f8f8;
    }

    .modal-footer {
      // background: linear-gradient(to bottom,rgba(0,0,0,.14),rgba(0,0,0,.03) 3px,transparent);
      background-color: #f8f8f8;
      text-align: center;
      font-size: 13px;
      a {
        text-decoration: underline
      }
    }
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

</style>
